import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Modal, Button, Table } from "react-bootstrap";

// ---------- STATIC HOSPITAL DATA ----------
const departments = [
  {
    name: "General Ward",
    icon: "bi-hospital",
    color: "linear-gradient(135deg, #4facfe, #00f2fe)",
    patientCount: 33,
  },
  {
    name: "Post Cath Ward",
    icon: "bi-heart-fill",
    color: "linear-gradient(135deg, #764ba2, #667eea)",
    patientCount: 21,
  },
  {
    name: "PAEDS Ward",
    icon: "bi-emoji-smile-fill",
    color: "linear-gradient(135deg, #f6d365, #85f9fd)",
    patientCount: 13,
  },
  {
    name: "Surgical Ward",
    icon: "bi-cpu",
    color: "linear-gradient(135deg, #43cea2, #185a9d)",
    patientCount: 9,
  },
  {
    name: "Coronary Care Unit-1",
    icon: "bi-hospital",
    color: "linear-gradient(135deg, #ff758c, #ff7eb3)",
    patientCount: 6,
  },
  {
    name: "Coronary Care Unit-2",
    icon: "bi-activity",
    color: "linear-gradient(135deg, #ff9966, #ff5e62)",
    patientCount: 3,
  },
];

// ---------- GENERATE STATIC PATIENT DATA ----------
const namesMale = [
  "Muhammad Sohail", "Bilal Ahmed", "Usman Khalid", "Tahir Iqbal",
  "Adnan Malik", "Ahmed Raza", "Qamar Aftab", "Zeeshan Ali", "Asad Khan"
];
const namesFemale = [
  "Ayesha Khan", "Khalida Bibi", "Maria Javed", "Zainab Fatima",
  "Iqra Shafi", "Sadia Noor", "Hina Riaz", "Nimra Abbas", "Rabia Tariq"
];
const issues = [
  "Fever", "Cough", "Typhoid", "Post Angioplasty Recovery", "Renal Failure",
  "Dehydration", "Chest Pain", "Sepsis", "Fracture", "Infection"
];

const generatePatients = (count) => {
  const patients = [];
  for (let i = 0; i < count; i++) {
    const gender = Math.random() > 0.5 ? "male" : "female";
    const name =
      gender === "male"
        ? namesMale[Math.floor(Math.random() * namesMale.length)]
        : namesFemale[Math.floor(Math.random() * namesFemale.length)];
    const issue = issues[Math.floor(Math.random() * issues.length)];
    const mrNo = "MR" + (1000 + i);
    const date = `2025-11-${String(1 + Math.floor(Math.random() * 3)).padStart(2, "0")}`;
    patients.push({ mrNo, name, issue, date, gender });
  }
  return patients;
};

departments.forEach((d) => (d.patients = generatePatients(d.patientCount)));

// ---------- MAIN COMPONENT ----------
export default function HospitalDepartments() {
  const [selectedDept, setSelectedDept] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleCardClick = (dept) => {
    setSelectedDept(dept);
    setShowModal(true);
  };

  const getAvatar = (name) => {
    const initials = name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
    const colors = ["#00bcd4", "#ff9800", "#4caf50", "#e91e63", "#3f51b5"];
    const bg = colors[Math.floor(Math.random() * colors.length)];
    return (
      <div
        className="rounded-circle text-white fw-bold d-inline-flex align-items-center justify-content-center me-2"
        style={{
          width: "38px",
          height: "38px",
          backgroundColor: bg,
          fontSize: "0.9rem",
        }}
      >
        {initials}
      </div>
    );
  };

  const genderIcon = (gender) =>
    gender === "female" ? (
      <i className="bi bi-gender-female text-danger ms-1"></i>
    ) : (
      <i className="bi bi-gender-male text-primary ms-1"></i>
    );

  return (
    <div className="min-vh-100 bg-light py-5 px-3">
      <div className="container">
        <h1 className="text-center mb-5 fw-bold text-primary">
          🏥 Rawalpindi Institute of Cardiology
        </h1>
<br>
</br>
<br></br>
        <div className="row g-4">
          {departments.map((dept, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4">
              <div
                className="card border-0 shadow-lg text-white h-100 position-relative overflow-hidden"
                style={{
                  background: dept.color,
                  borderRadius: "20px",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onClick={() => handleCardClick(dept)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.04)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                <div className="card-body d-flex flex-column justify-content-between">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div
                      className="bg-white bg-opacity-25 rounded-circle p-3"
                      style={{ fontSize: "1.8rem" }}
                    >
                      <i className={`bi ${dept.icon}`}></i>
                    </div>
                    <span className="badge bg-white bg-opacity-50 text-dark fs-6">
                      #{index + 1}
                    </span>
                  </div>
                  <div>
                    <h4 className="fw-bold mb-3">{dept.name}</h4>
                    <p className="mb-1 fs-6 text-white">Patients Admitted</p>
                    <h2 className="fw-bolder text-white">{dept.patients.length}</h2>
                  </div>

                  <div
                    className="progress mt-3"
                    style={{ height: "8px", backgroundColor: "rgba(255,255,255,0.3)" }}
                  >
                    <div
                      className="progress-bar bg-white"
                      style={{
                        width: `${Math.min(dept.patients.length * 3, 100)}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MODAL */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" dialogClassName="custom-modal">
          {selectedDept && (
            <>
              {/* Header */}
              <div
                className="p-3 text-white"
                style={{
                  background: selectedDept.color,
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="bg-white bg-opacity-25 rounded-circle p-2"
                      style={{ fontSize: "1.4rem" }}
                    >
                      <i className={`bi ${selectedDept.icon}`}></i>
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0">{selectedDept.name}</h5>
                      <small className="opacity-75">
                        Total Patients: {selectedDept.patients.length}
                      </small>
                    </div>
                  </div>
                  <Button
                    variant="light"
                    size="sm"
                    onClick={() => setShowModal(false)}
                    className="fw-bold rounded-circle border-0"
                  >
                    ✖
                  </Button>
                </div>
              </div>

              {/* Body */}
              <Modal.Body className="bg-light px-4 py-3">
                <div className="card border-0 shadow-sm rounded-4 p-3">
                  <h6 className="fw-bold mb-3 text-primary">Patient Details</h6>
                  <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <Table hover responsive className="align-middle mb-0">
                      <thead className="table-primary">
                        <tr>
                          <th>Patient</th>
                          <th>Issue</th>
                          <th>MR No</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDept.patients.map((p, i) => (
                          <tr key={i}>
                            <td className="d-flex align-items-center">
                              {getAvatar(p.name)}
                              <div>
                                {p.name} {genderIcon(p.gender)}
                              </div>
                            </td>
                            <td>{p.issue}</td>
                            <td>{p.mrNo}</td>
                            <td>{p.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Modal.Body>

              {/* Footer */}
              <Modal.Footer className="border-0 bg-white rounded-bottom-4 px-4">
                <Button variant="outline-primary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        <footer className="text-center mt-5 text-secondary small">
          © {new Date().getFullYear()} Rawalpindi Institute of Cardiology — Smart Health Dashboard
        </footer>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .custom-modal .modal-content {
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          animation: fadeInUp 0.4s ease;
        }

        @keyframes fadeInUp {
          0% {
            transform: translateY(20px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .table th {
          border-top: none;
        }
      `}</style>
    </div>
  );
}
